import {ITheme} from 'contexts/ThemeContext';
import {Platform, StyleSheet} from 'react-native';

export default (
  props: ITheme,
  isBigPhoto: boolean,
  isPhotoOnTheHomeGreeting: boolean,
) => {
  const platform = Platform.OS === 'web' ? 'web' : 'noweb';

  const getSize = (
    type:
      | 'userContainerHeight'
      | 'userContainerWidth'
      | 'userContainerBorderRadius'
      | 'userContainerMarginRight'
      | 'userTextContainerSize',
  ) => {
    const source = {
      userContainerHeight: {
        web: isBigPhoto ? 135 : 32,
        noweb: isBigPhoto ? 92 : isPhotoOnTheHomeGreeting ? 46 : 30,
      },
      userContainerWidth: {
        web: isBigPhoto ? 135 : 32,
        noweb: isBigPhoto ? 92 : isPhotoOnTheHomeGreeting ? 46 : 30,
      },
      userContainerBorderRadius: {
        web: isBigPhoto ? 64 : 16,
        noweb: isPhotoOnTheHomeGreeting ? 30 : 60,
      },
      userContainerMarginRight: {web: isBigPhoto ? 0 : 8, noweb: 0},
      userContainerPaddingLeft: {web: 0, noweb: isBigPhoto ? 0 : 16},
      userTextContainerSize: {
        web: isBigPhoto ? 32 : 13,
        noweb: isBigPhoto ? 32 : 9,
      },
    };

    return source[type][platform];
  };

  return StyleSheet.create({
    maineUserContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
    },
    userContainer: {
      width: getSize('userContainerWidth'),
      height: getSize('userContainerHeight'),
      borderRadius: getSize('userContainerBorderRadius'),
      marginRight: getSize('userContainerMarginRight'),
      marginLeft: 10,
      backgroundColor: props.colors.purple(0.2),
      justifyContent: 'center',
      alignItems: 'center',
    },
    userTextForPhoto: {
      fontSize: getSize('userTextContainerSize'),
      color: props.colors.cornflowerBlue,
    },
    userText: {
      marginLeft: 16,
      fontSize: 17,
      color: props.colors.black,
      ...props.typography.notoSansRegular,
    },
  });
};
